import { useState, useEffect } from 'react';

/**
 * Hook personnalisé pour détecter si une media query correspond à l'écran actuel
 * @param {string} query - La media query à vérifier (ex: '(max-width: 768px)')
 * @returns {boolean} - Retourne true si la media query correspond, false sinon
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Créer un MediaQueryList pour la requête
    const mediaQuery = window.matchMedia(query);
    
    // Définir l'état initial
    setMatches(mediaQuery.matches);

    // Créer un gestionnaire d'événements pour les changements
    const handler = (event) => {
      setMatches(event.matches);
    };

    // Ajouter l'écouteur d'événements
    mediaQuery.addEventListener('change', handler);
    
    // Nettoyer l'écouteur lors du démontage du composant
    return () => {
      mediaQuery.removeEventListener('change', handler);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
